// extracted by mini-css-extract-plugin
export var centerText = "_7t-8";
export var container = "_7t-0";
export var doughnutContainer = "_7t-7";
export var legend = "_7t-a";
export var legendItemColorDisplay = "_7t-b";
export var legendItemLabel = "_7t-d";
export var legendItemValue = "_7t-c";
export var lg = "_7t-5";
export var maxWidth = "_7t-9";
export var md = "_7t-4";
export var responsive = "_7t-6";
export var sm = "_7t-3";
export var xs = "_7t-2";
export var xxs = "_7t-1";